import {
    request
} from '../lib/http_request'
import {
    apis
} from '../lib/apis'

// 维护公告列表
const noticeMaintenanceList = obj => new Promise((resolve, reject) => {
    const {
        token
    } = obj
    request({
        url: apis.notice_maintenances_list + '?token=' + token
    }).then(res => {
        resolve(res);
    })
})

// 创建维护公告
const noticeMaintenanceSend = obj => new Promise((resolve, reject) => {
    const {
        noticeMaintenanceForm,
        token
    } = obj
    request({
        url: apis.notice_maintenance_send + '?token=' + token,
        data: noticeMaintenanceForm
    }).then(res => {
        resolve(res);
    })
})

// 编辑维护公告
const noticeMaintenanceEdit = obj => new Promise((resolve, reject) => {
    const {
        noticeMaintenanceForm,
        token
    } = obj
    request({
        url: apis.notice_maintenance_edit + '?token=' + token ,
        data: noticeMaintenanceForm
    }).then(res => {
        resolve(res);
    })
})

// 删除维护公告
const noticeMaintenanceDelete = obj => new Promise((resolve, reject) => {
    const {
        noticeMaintenanceForm,
        token
    } = obj
    request({
        url: apis.notice_maintenance_delete + '?token=' + token ,
        data: noticeMaintenanceForm
    }).then(res => {
        resolve(res);
    })
})


export default {
    noticeMaintenanceList,
    noticeMaintenanceSend,
    noticeMaintenanceEdit,
    noticeMaintenanceDelete,
}



// WEBPACK FOOTER //
// ./src/service/notice_maintenance_api.js